import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";
import { getMe } from "../services/authService";
import { listBrokerageAccounts } from "../services/brokerageService";

const DISMISS_KEY = "mfa_banner_dismissed";

export function MfaWarningBanner() {
  const user = useAuthStore((s) => s.user);
  const [showBanner, setShowBanner] = useState(false);
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(DISMISS_KEY) === "1",
  );

  useEffect(() => {
    if (!user || dismissed) return;

    console.log("[MfaBanner] checking for user", user.id);

    getMe()
      .then((freshUser) => {
        console.log("[MfaBanner] getMe result: mfa_enabled=", freshUser.mfa_enabled);
        if (freshUser.mfa_enabled) return;
        return listBrokerageAccounts().then((res) => {
          console.log("[MfaBanner] brokerage accounts:", res.accounts.length);
          if (res.accounts.length > 0) {
            setShowBanner(true);
          }
        });
      })
      .catch((err) => {
        console.error("[MfaBanner] ERROR:", err);
      });
  }, [user?.id, dismissed]);

  if (!showBanner || dismissed) return null;

  return (
    <div className="bg-amber-600 dark:bg-amber-500/10 border-b border-amber-700 dark:border-amber-500/30 px-4 py-2.5 flex items-center justify-between gap-3">
      <div className="flex items-center gap-2 min-w-0">
        <svg
          className="w-4 h-4 text-white dark:text-amber-400 flex-shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4.5c-.77-.833-2.694-.833-3.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z"
          />
        </svg>
        <span className="text-xs sm:text-sm text-white dark:text-amber-200">
          Your account has brokerage access but MFA is not enabled.{" "}
          <Link
            to="/profile"
            className="underline text-white dark:text-amber-100 hover:text-amber-100 dark:hover:text-white font-medium"
          >
            Enable MFA
          </Link>{" "}
          to protect your account.
        </span>
      </div>
      <button
        type="button"
        onClick={() => {
          setDismissed(true);
          sessionStorage.setItem(DISMISS_KEY, "1");
        }}
        className="text-white dark:text-amber-400 hover:text-amber-100 dark:hover:text-amber-200 p-1 flex-shrink-0"
        aria-label="Dismiss"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}
